/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementPropertyFilterDtoMeasurementProperty } from './TrackItMeasurementPropertyFilterDtoMeasurementProperty';
import {
    TrackItMeasurementPropertyFilterDtoMeasurementPropertyFromJSON,
    TrackItMeasurementPropertyFilterDtoMeasurementPropertyFromJSONTyped,
    TrackItMeasurementPropertyFilterDtoMeasurementPropertyToJSON,
} from './TrackItMeasurementPropertyFilterDtoMeasurementProperty';

/**
 * 
 * @export
 * @interface TrackItMeasurementPropertyFilterDto
 */
export interface TrackItMeasurementPropertyFilterDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementPropertyFilterDto
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementPropertyFilterDto
     */
    isEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementPropertyFilterDto
     */
    isCustom?: boolean;
    /**
     * 
     * @type {TrackItMeasurementPropertyFilterDtoMeasurementProperty}
     * @memberof TrackItMeasurementPropertyFilterDto
     */
    measurementProperty?: TrackItMeasurementPropertyFilterDtoMeasurementProperty | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementPropertyFilterDto
     */
    $type?: TrackItMeasurementPropertyFilterDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementPropertyFilterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementPropertyFilterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementPropertyFilterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementPropertyFilterDtoTypeEnum = typeof TrackItMeasurementPropertyFilterDtoTypeEnum[keyof typeof TrackItMeasurementPropertyFilterDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementPropertyFilterDto interface.
 */
export function instanceOfTrackItMeasurementPropertyFilterDto(value?: unknown): value is TrackItMeasurementPropertyFilterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementPropertyFilterDtoTypeEnum)[0];
}

export function TrackItMeasurementPropertyFilterDtoFromJSON(json: any): TrackItMeasurementPropertyFilterDto {
    return TrackItMeasurementPropertyFilterDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementPropertyFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementPropertyFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isCustom': json['isCustom'] == null ? undefined : json['isCustom'],
        'measurementProperty': json['measurementProperty'] == null ? undefined : TrackItMeasurementPropertyFilterDtoMeasurementPropertyFromJSON(json['measurementProperty']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementPropertyFilterDtoToJSON(value?: TrackItMeasurementPropertyFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'isEnabled': value['isEnabled'],
        'isCustom': value['isCustom'],
        'measurementProperty': TrackItMeasurementPropertyFilterDtoMeasurementPropertyToJSON(value['measurementProperty']),
        '$type': value['$type'],
    });
}

